<template>
  <transition name="modalfile">
    <div class="modal-mask fixed top-0 left-0 w-full h-auto outline-none fade">
      <div
        class="modal-container w-full mt-5 mb-10 mx-auto rounded shadow-lg z-50 h-full bg-white"
      >
        <header class="h-8 p-4 pt-4 pb-4 w-10/12 mx-auto">
          <ul class="flex space-x-6  cursor-pointer fixed right-0 items-center mt-0 rounded-2 mr-10  z-50">
            <li >
              <button
              @click="download()"
            type="button"
            class="
              filter-bar-button
              text-gray-800
              hover:opacity-75
              focus:outline-none
            "
          >
            <i class="fas fa-file-download"></i>
            Download
          </button>

            </li>
            <li>
              <i
            class="fas fa-times text-black text-3xl"
            @click="$emit('close')"
            style="right: -12px"
          ></i>
            </li>
          </ul>
        

         
        </header>
        <div
          class="h-screen overflow-y-auto w-12/12 mx-auto section-content white"
        >
          <slot name="body">
            <div
              style="width: 100%; text-align: center"
              class="spin-holder"
              v-if="loading"
            >
              <i class="spinner fa fa-atom fa-spin"></i>
              <p>Loading File</p>
            </div>

            <div v-if="!displayDocument && !loading" class="p-10 w-11/12">
              <h2 class="font-bold text-xl">The document is not available</h2>
              <p class="pt-2 font-semibold">
                This selected document is not currently available.
              </p>
              <p class="pt-2">
                We are constantly aiming to improve our product and adding more
                content so please try back again later or contact the Primary PE
                Passport office for further help or information.
              </p>
            </div>

            <div class="h-full w-full ">
              <div v-if="displayDocument">
                <template v-if="isPDF && isImage == false">
                  <pdf
                    ref="myPdfComponent"
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                    :src="pdfsrc"
                    class="w-1/2 mx-auto"
                  >
                    <template slot="loading">
                      loading content here...
                    </template>
                  </pdf>

                </template>
                <iframe
                v-else-if="isImage == false"
                  v-bind:src="pathUrl"
                  width="100%"
                  height="100%"
                  class="pt-8 "
                  @load="fileLoaded"
                  ref="reference"
                />
        <img
          :src="pathUrl"
          :alt="title"
          class="gallery-image"
          ref="reference"
          :title="title"
          @contextmenu.prevent="handler"
          v-else
        />
              </div>
            </div>
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer"> </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";
import pdfvuer from "pdfvuer";

export default {
  name: "modalfile",
  mixins: [fileResourceMixin],
  props: {
    url: { type: String, required: true },
    format: { type: String, required: true },
    title: { type: String, required: false },
  },
  computed: {
    extension() {
      return this.url.split(".").pop();
    },
    isImage() {
      let imageExtensions = ["jpg", "png"];
      return imageExtensions.includes(this.extension);
    },
    titleDisplay() {
      return this.title != undefined ? this.title : "";
    },
    displayDocument() {
      if (this.loading === false && this.hasError === false) {
        return true;
      }

      return false;
    },
    isPDF() {
      return this.extension === "pdf";
    },
  },
  data: function () {
    return {
      pathUrl: "",
      loading: true,
      hasError: false,
      numPages: null,
      pdfsrc: null,
      typeFolder: this.format
    };
  },
  created() {
    if (this.typeFolder == "document") {
      this.typeFolder = this.typeFolder + "s"
    }
    if (this.isPDF) {
      this.loadData();
    } else {
      this.loadMedia();
    }
  },
  methods: {
    loadData() {
      setTimeout(() => {
        this.getFileDataByType(this.url, this.typeFolder).then((result) => {
          const url = URL.createObjectURL(result.Body);
          this.pdfsrc = pdfvuer.createLoadingTask(url);
          this.pdfsrc.then((pdf) => {
            this.numPages = pdf.numPages;
          });
          this.loading = false;
        });
      }, 1000);
    },
    loadMedia() {
      this.hasError = false;
      setTimeout(() => {
        this.getFileByType(this.url, this.typeFolder)
          .then((f) => {
            var encodedUrl = encodeURIComponent(f);
            let file = (this.pathUrl =
              this.isImage == true || this.extension == "pdf"
                ? f
                : "https://docs.google.com/viewer?url=" +
                  encodedUrl +
                  "&embedded=true");

            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log("ERROR", err);
          });
      }, 1000);
    },
    fileLoaded(e) {
      console.log("REF", this.$refs.reference);
    },
    download() {
      this.getFileByType(this.url, this.typeFolder)
          .then((f) => {
            window.open(f, '_blank');
          })

    }
  },
  components: {
    pdf: pdfvuer,
  },
};
</script>

<style scoped>
.document {
  padding-top: -50px;
}

.modal-body {
  overflow-y: scroll;
}

.spin-holder {
  margin-top: 20%;
}
</style>
